module.exports = __webpack_public_path__ + "06a16ee27556b368a92c0a99e02198b7.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Light.ttf
// module id = 376
// module chunks = 0